import { TFunction } from 'i18next';
import * as Yup from 'yup';

import { getCoordinateValidationSchema } from 'features/reports/components/ReportForm/utils';
import { getReportMessageValidationSchema } from 'features/wildfires/utils/getReportMessageValidationSchema';

export const getValidationSchema = (t: TFunction): Yup.SchemaOf<object> =>
  Yup.object().shape(
    {
      azimuth: Yup.number().when('status', {
        is: 'approve',
        then: Yup.number()
          .typeError(t('moderateSubmission.inputs.azimuth.required'))
          .min(0, t('moderateSubmission.inputs.azimuth.required'))
          .max(360, t('moderateSubmission.inputs.azimuth.required')),
        otherwise: Yup.number().notRequired(),
      }),
      description: Yup.string().when('status', {
        is: 'approve',
        then: getReportMessageValidationSchema(t),
        otherwise: Yup.string().notRequired(),
      }),
      geoEventId: Yup.number().when('status', {
        is: 'approve',
        then: Yup.number().required(
          t('moderateSubmission.inputs.incident.required'),
        ),
        otherwise: Yup.number().nullable().notRequired(),
      }),
      latitude: Yup.string().when('status', {
        is: 'approve',
        then: getCoordinateValidationSchema({
          t,
          coordType: 'latitude',
          whenPropKey: 'longitude',
        }),
        otherwise: Yup.string().nullable().notRequired(),
      }),
      longitude: Yup.string().when('status', {
        is: 'approve',
        then: getCoordinateValidationSchema({
          t,
          coordType: 'longitude',
          whenPropKey: 'latitude',
        }),
        otherwise: Yup.string().nullable().notRequired(),
      }),
      status: Yup.string().required(
        t('moderateSubmission.inputs.status.required'),
      ),
      postMethod: Yup.string().when('status', {
        is: 'approve',
        then: Yup.string().required(
          t('moderateSubmission.inputs.postMethod.required'),
        ),
        otherwise: Yup.string(),
      }),
    },
    [['latitude', 'longitude']],
  );
